<div class="form" [formGroup]="form" [class.disabled]="isDisabled">
  <div
    class="account-select-wrapper"
    #dropdownRef="fuDropdownTrigger"
    [fuDropdownTriggerFor]="dropdown"
    [class.with-value]="accountCtrl.value"
    [class.error]="amountError || accountError"
    [class.in-focus]="dropdownRef.isDropdownOpened$ | async"
  >
    <div class="account-select" (click)="$event.stopPropagation()">
      @let selectedAccount = accountCtrl.value;
      @if (selectedAccount) {
        <div class="selected-account-view">
          <div class="selected-account" (click)="openDropdown(); onTouched()">
            @switch (selectedAccount.viewType) {
              @case ("user") {
                <iw-user-item [user]="selectedAccount" selected />
              }
              @case ("currency") {
                <iw-currency-item [account]="selectedAccount" selected />
              }
              @default {
                <iw-account-item [account]="selectedAccount" selected />
              }
            }
          </div>
          @if (withAmount()) {
            <div class="amount-input-container">
              <div
                class="amount-input"
                (click)="
                  amountInput.inputElement.nativeElement.focus(); onTouched()
                "
                [class.active]="amountInput.isFocused || amountCtrl.value"
              >
                @if (!!+amountCtrl.value) {
                  <div class="symbol">{{ isAccountSender() ? "-" : "+" }}</div>
                }
                <div class="input-wrapper">
                  <fu-simple-input
                    #amountInput
                    formControlName="amount"
                    placeholder="0"
                    [useOutlineLabel]="false"
                    [maskPattern]="
                      'separator.' + selectedAccount.currency?.decimals
                    "
                    [dropSpecialCharacters]="false"
                    [decimalMarker]="['.', ',']"
                    (focusout)="normalizeOnFocusOut($event)"
                    (focused)="focusInput()"
                  />
                </div>
                <div class="currency">
                  <fu-icon
                    [iconName]="selectedAccount.currency?.symbol.toLowerCase()"
                    [size]="20"
                  />
                </div>
              </div>
              @if (amountError) {
                @if (isDesktop()) {
                  <p class="amount-input-error">
                    {{ amountError | translate }}
                  </p>
                } @else if (amountInput.isFocused) {
                  <div class="mobile-amount-input-error" [@slideFromTop]>
                    <div class="mobile-amount-input-error-toast">
                      <div class="mobile-amount-input-error-toast-icon">
                        <fu-icon size="20" iconName="alert-triangle" />
                      </div>
                      <p class="mobile-amount-input-error-toast-text">
                        {{ amountError | translate }}
                      </p>
                    </div>
                  </div>
                }
              }
            </div>
          }
        </div>
      } @else {
        <div class="empty-account-view" (click)="openDropdown(); onTouched()">
          <fu-icon
            [size]="isDesktop() ? 22 : 20"
            [iconName]="
              isAccountSender() ? 'account-sender' : 'account-receiver'
            "
          />
          <div class="placeholder">{{ placeholder() | translate }}</div>
          <fu-icon class="arrow" iconName="arrow-bottom-big" size="32" />
          @if (accountError) {
            <div class="account-input-error">
              <p class="amount-input-error text-ellipsis">
                {{ accountError | translate }}
              </p>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <fu-dropdown #dropdown>
    <div class="dropdown">
      @if (withSearch()) {
        <div class="search">
          <fu-simple-input
            formControlName="search"
            [useOutlineLabel]="false"
            [label]="'accountWithAmount.search.label' | translate"
            [placeholder]="searchPlaceholder() | translate"
            (click)="$event.stopPropagation()"
          />

          <fu-icon class="search-icon" iconName="search" size="16" />
        </div>
      }

      @if (accounts()?.length) {
        <div class="accounts">
          @for (account of accounts(); track account.id) {
            <div
              class="account-item"
              (click)="selectAccount(account)"
              [class.disabled]="isItemDisabled(account)"
            >
              @switch (account.viewType) {
                @case ("user") {
                  <iw-user-item [user]="account" />
                }
                @case ("currency") {
                  <iw-currency-item [account]="account" />
                }
                @default {
                  <iw-account-item
                    [account]="account"
                    [defaultCurrency]="defaultCurrency()"
                  />
                }
              }
            </div>
          }
        </div>
      } @else {
        <div class="empty-list">
          <fu-icon class="icon" iconName="help-circle" size="20" />

          <p class="message">
            <span class="message-title">{{
              "accountWithAmount.emptyList.title" | translate
            }}</span>
            <span class="message-subtitle">
              {{ "accountWithAmount.emptyList.subtitle" | translate }}</span
            >
          </p>
        </div>
      }
    </div>
  </fu-dropdown>
</div>
